import { BaseResourceModel } from '../../models/base-resource.model';
import { EmpenhoExtra } from './empenho-extra.model';

// tslint:disable: variable-name

export class EmpenhoExtraDeducaoReinf extends BaseResourceModel {
    constructor(
        public id?: number,
        public tipo?: number,
        public valor_deducao?: number,
        public previdencia_complementar?: boolean,
        public cnpj_previdencia_complementar?: string,
        public valor_patrocinador?: number,
        public empenho_extra?: EmpenhoExtra,
    ) {
        super();
    }

    static converteJson(json: any): EmpenhoExtraDeducaoReinf {
        return Object.assign(new EmpenhoExtraDeducaoReinf(), json);
    }
}
